var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-dark align-self-start app-file-uploader",
    class: {
      'app-file-uploader--has-error': _vm.hasError
    }
  }, [_vm.showDeletedAction ? _c('b-form-file', {
    ref: "file-input",
    staticClass: "app-file-uploader__file-input",
    attrs: {
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "change": _vm.upload
    }
  }) : _vm._e(), _c('div', {
    staticClass: "app-file-uploader__action-bar"
  }, [_vm.fileUrl && _vm.showDeletedAction ? _c('a', {
    staticClass: "app-file-uploader__clean-button",
    on: {
      "click": _vm.handleCleanIsClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })]) : _vm._e(), _c('a', {
    staticClass: "app-file-uploader__current-url",
    attrs: {
      "href": _vm.fileUrl,
      "target": "_blank"
    }
  }, [_vm.fileUrl ? [_vm.placeholderWhenUploaded === null ? _c('small', [_vm._v("目前路徑：" + _vm._s(_vm.fileUrl))]) : _c('small', [_vm._v(_vm._s(_vm.placeholderWhenUploaded))])] : [_vm.placeholderWhenEmpty === null ? _c('small', [_vm._v("目前路徑：未上傳")]) : _c('small', [_vm._v(_vm._s(_vm.placeholderWhenEmpty))])]], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }